"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isNonEmptyListItem = exports.isEmptyListItem = void 0;
/**
 * @deprecated - empty items are no longer present and needed in the attribute filter elements list
 * @public
 */
exports.isEmptyListItem = function (item) {
    return item && item.empty;
};
/**
 * @deprecated - empty items are no longer present and needed in the attribute filter elements list
 * @public
 */
exports.isNonEmptyListItem = function (item) {
    return item && !item.empty;
};
//# sourceMappingURL=deprecated.js.map